import { TimerCancelIcon } from './TimerCancelIcon';

/**
 * author: Colton Wiscombe
 * id B155A30F-D5A6-4981-A072-B565DA53872D
 * name timer-cancel
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-cancel.svg
 * tags
 * - Date / Time 
 */
export const StopwatchCancelIcon = TimerCancelIcon;
export default StopwatchCancelIcon